
import { Component, OnInit, ViewChild } from '@angular/core';
import { ObjectHelper } from '@barthauer/abc/core';
import { TargetColumnValue } from '@barthauer/abc/core/data';
import { AbcListComponent, AbcPopupComponent } from '@barthauer/abc/ui-components';
import { ParameterNames } from 'libs/abc/arena/src/lib/abc-arena.service';
import { TargetLayoutInfo } from 'libs/abc/arena/src/lib/core/higon/higon.model';
import { NavigationLayoutViewModel } from 'libs/abc/arena/src/lib/core/navigation/navigation.viewModel';
import { LayoutViewModel } from 'libs/abc/arena/src/lib/core/viewModels/layout.viewModel';
import { Subject } from 'rxjs';
import { AbcArenaService } from '../../abc-arena.service';
import { DataService } from '../../services/data.service';
import { GoToService } from '../../services/go-to.service';
import { ArenaService } from '../arena.service';

@Component({
    selector: 'arena-go-to',
    imports: [AbcPopupComponent, AbcListComponent],
    templateUrl: './go-to.component.html',
    styleUrls: ['./go-to.component.scss']
})
export class GoToComponent implements OnInit {
  private destroy$ = new Subject();
  private isPopupHidden = true;
  public targetLayouts: Array<NavigationLayoutViewModel> = [];
  private targetLayoutsWithFilter: Array<{ layout: NavigationLayoutViewModel; target: TargetLayoutInfo }> = [];
  private refObjectId: string;
  private refObjectType: string | number;

  @ViewChild('abcPopup') public abcPopup: AbcPopupComponent;
  @ViewChild('abcList') public abcList: AbcListComponent;

  constructor(
    private arena: ArenaService,
    private abcArena: AbcArenaService,
    private data: DataService,
    public service: GoToService
  ) {}

  public ngOnInit(): void {}

  public onHiding() {
    this.destroy$.next(null);
    this.targetLayouts = [];
    this.isPopupHidden = true;
  }

  public async go(layout: NavigationLayoutViewModel): Promise<void> {
    this.abcPopup?.instance?.hide();
    let target: TargetLayoutInfo = this.targetLayoutsWithFilter.find((_) => _.layout === layout)?.target;

    let ly: LayoutViewModel | undefined = undefined;
    if (!this.arena.externalComponent) {
      ly = await this.data.getLayout(this.arena.arenaName, layout.layoutName);
    }
    const id = this.refObjectId ?? this.abcArena.currentDataEntity?.Id;
    const ot = this.refObjectType ?? this.abcArena.currentDataEntity?.ObjectType;
    target = {
      layout: ly ?? layout,
      targetLayoutOPath: target?.targetLayoutOPath ?? 'Id = $' + ParameterNames.IdOfObjectInParentLayout,
      sourceId: target?.sourceId ?? id,
      sourceObjectType: target.sourceObjectType ?? ot,
      column: target?.column,
      isColumnInTarget: target?.isColumnInTarget,
      denyInsert: target?.denyInsert,
      openInNewTab: target?.openInNewTab,
    };
    await this.arena.actions.openSubLayout(target);
  }

  public async showTargetLayouts(
    objectType: string,
    refObjectId: string,
    oPath?: string,
    values?: TargetColumnValue[],
    openInNewTab?: boolean
  ): Promise<void> {
    try {
      const tl = await this.service.getPossibleTargetLayouts(
        objectType,
        oPath ?? '',
        refObjectId,
        values ?? [],
        null,
        openInNewTab
      );
      this.refObjectId = refObjectId;
      this.refObjectType = undefined;
      this.showTargetNavigationLayouts(tl);
    } catch (err) {
      this.data.abcCore.error.publish(err);
    }
  }

  public async showTargetNavigationLayouts(
    targets: { layout: NavigationLayoutViewModel; target: TargetLayoutInfo }[],
    openInNewTab?: boolean
  ): Promise<void> {
    try {
      this.targetLayoutsWithFilter = [];
      this.targetLayouts = [];
      this.abcPopup?.instance?.hide();
      this.targetLayoutsWithFilter = targets ?? [];
      this.targetLayouts = this.targetLayoutsWithFilter.map((_) => _.layout);
      if (typeof openInNewTab === 'boolean') {
        for (const r of this.targetLayoutsWithFilter) {
          if (r.target) {
            r.target = ObjectHelper.cloneDeep(r.target);
            r.target.openInNewTab = openInNewTab;
          }
        }
      }
      if (this.targetLayouts.length === 1) {
        await this.go(this.targetLayouts[0]);
      } else {
        if (this.abcList) {
          this.abcList.searchValue = '';
        }
        if (this.isPopupHidden) {
          this.abcPopup?.instance?.show();
        }
      }
    } catch (err) {
      this.data.abcCore.error.publish(err);
    }
  }

  public onPopupInitialized(event: any) {
    if (this.targetLayouts.length > 1) {
      this.abcPopup?.instance?.show();
      this.isPopupHidden = false;
    }
  }
}
